module.exports = __webpack_public_path__ + "img/logo-lab-hoh.01071e0e.svg";